import ScrollPage, { SectionItem } from "../../Components/ScrollPage/ScrollPage";
import Section from "../../Components/Section/Section";
import { Article, ArticleElement } from "../../Components/Article/ArticleComp";
import { useParams } from "react-router-dom";
import NewsReleases from "../../Components/Article/NewsReleases.json";

interface ScrollTo {
    index: number;
}

export const Sections: SectionItem[] = [
    { label: "Article", id: "article" }
];


const ArticlePage: React.FC<ScrollTo> = ({ index }) => {
    const { slug } = useParams<{ slug?: string }>();

    // Optional: fallback or guard
    // if (!slug) {
    //     return <div>Article not found</div>;
    // }

    return (
        <ScrollPage index={index} sections={Sections}>
            <Section section={Sections[0].id}>

                {!slug ? (
                    <div className="needPermission">
                        <h2>
                            There is no article under the given name
                        </h2>
                    </div>
                ) : (

                    <ArticleElement slug={slug} articles={NewsReleases as Article[]}/>
                )}
            </Section>
        </ScrollPage>
    );
};

export default ArticlePage;